import { EnrolmentNotRecognizedTrigger } from '@/models/transitions/triggers/enrolment-not-recognized-trigger';
import { NullTrigger } from '@/models/transitions/triggers/null-trigger';
import ReviewReasonFactory from '@/models/review-reason-factory';
import { EnrolmentReviewState } from './enrolment-review-state';

export class TriggerSelectionReviewState extends EnrolmentReviewState {
	public display(): void {
		this.review.popups.showTriggerSelectionPopup();
	}

	public canPerformNext(): boolean {
		// A prefilled-but-retired status (e.g. old "Other, please specify") opens on no selection; require a real choice.
		return !(this.review.selectedTrigger instanceof NullTrigger);
	}

	public requiresAdditionalInput(): boolean {
		// Only when not mass-reviewing and the selected enrolment status requires no further input, no next step is needed.
		return (
			this.review.enrolments.length > 1 ||
			this.review.selectedTrigger instanceof EnrolmentNotRecognizedTrigger ||
			!this.review.selectedTrigger.payloadConfiguration.isEmpty()
		);
	}

	public next(): void {
		if (this.review.selectedTrigger instanceof EnrolmentNotRecognizedTrigger) {
			this.review.changeAvailableReviewReasons(ReviewReasonFactory.obtainNotEnrolledReasons());
			this.review.transitionTo(this.review.createReviewReasonSelectionState());
			return;
		}

		if (this.review.selectedTrigger.payloadConfiguration.isEmpty()) {
			this.review.transitionTo(this.review.createTriggerMassReviewConfirmationState());
			return;
		}

		if (this.review.selectedTrigger.payloadConfiguration.includeSuccessFeeInformation) {
			this.review.transitionTo(this.review.createSuccessFeeSelectionState());
		} else {
			this.review.transitionTo(this.review.createTriggerPayloadReviewState());
		}
	}
}
